import {AbstractControl, FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {merge, Observable} from "rxjs";
import {filter, map, switchMapTo} from "rxjs/operators";
import {AddMultipleFormatsToCartModel} from "../models/cart/add-multiple-formats-to-cart.model";
import {AddToCartFormatModel} from "../models/cart/add-to-cart-format.model";
import {ProductFormatModel} from "../models/product/product-format.model";
import {ObservableBaseForm} from "./observable-base.form";

export class AddMultipleFormatsToCartForm extends ObservableBaseForm<AddMultipleFormatsToCartModel> {
    private emittedModel: AddMultipleFormatsToCartModel;

    public get formats(): FormArray {
        return this.formInstance.get("formats") as FormArray;
    }

    public get region(): AbstractControl {
        return this.formInstance.get("regionId");
    }

    public static createForm(formBuilder: FormBuilder, productId: number, formats: Array<ProductFormatModel>, regionId: number): AddMultipleFormatsToCartForm {
        const formatsArray = formBuilder.array([]);

        const formGroup = formBuilder.group({
            productId: formBuilder.control(productId, Validators.required),
            formats: formatsArray,
            regionId: formBuilder.control(regionId)
        });

        const initialValues = new AddMultipleFormatsToCartModel(productId, this.mapFormats(formats), regionId);

        const form = new AddMultipleFormatsToCartForm(formBuilder, formGroup, initialValues);
        form.handleFormatsUpdate(formats);

        return form;
    }

    private static mapFormats = (source: Array<ProductFormatModel>): Array<AddToCartFormatModel> => {
        return source.map(format => new AddToCartFormatModel(format.id.toString(), 0));
    }

    public constructor(
        private formBuilder: FormBuilder,
        formInstance: FormGroup,
        initialValues: AddMultipleFormatsToCartModel,
    ) {
        super(formInstance, initialValues);
        merge(
            this.changeObservable,
            this.submitObservable
        )
        .subscribe(model => this.emittedModel = model);
    }

    public handleFormatsUpdate(formatModels: Array<ProductFormatModel>): void {
        this.removeChangeListener();

        while (this.formats.controls.length) {
            this.formats.removeAt(0);
        }

        formatModels.map(format => {
            let quantity = 0;
            if (this.emittedModel) {
                const emittedFormat = this.emittedModel.formats.find(x => x.id === format.id.toString());
                if (emittedFormat) {
                    quantity = emittedFormat.quantity;
                }
            }

            const formatControl = this.formBuilder.control(new AddToCartFormatModel(format.id.toString(), quantity));
            return formatControl;
        }).forEach(control => this.formats.push(control));

        this.addChangeListener();
    }

    public reset(): void {
        for (const format of this.formats.controls) {
            format.setValue(new AddToCartFormatModel(format.value.id, 0), {emitEvent: false});
        }
    }

    protected createChangeSubscription(): Observable<AddMultipleFormatsToCartModel> {
        return merge(
            this.formats.valueChanges,
            this.region.valueChanges
        )
        .pipe(
            switchMapTo(this.formInstance.statusChanges
                .pipe(filter(this.validate))
            ),
            map(status => this.getModel())
        );
    }
}
